var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section-view',{attrs:{"title":_vm.title,"tips":_vm.tips}},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index},[_c('b',[_c('i'),_vm._v(_vm._s(item[_vm.titleKey]))]),_c('p',[_vm._v(_vm._s(item[_vm.contentKey]))])])}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }